import {POST, GET} from "@/services/gateway";

const register = ({
                    firstName,
                    lastName,
                    businessEmail,
                    CompanyName,
                    CompanySize,
                    JobFunction,
                    JobLevel,
                    country,
                    postalCode,
                    password,
                    confirmPassword,
                    region,
                    AcceptTerms
                  }) => {
  return POST('account/register',
    {
      firstName,
      lastName,
      businessEmail,
      CompanyName,
      CompanySize,
      JobFunction,
      JobLevel,
      country,
      postalCode,
      password,
      confirmPassword,
      region,
      AcceptTerms: true
    }
  )
}

const authenticate = ({email, password}) => {
  return POST('account/authenticate', {email, password})
}

const getSelf = () => {
  return GET('user/self')
}

// const googleConnect = ({adminEmail, serviceAccount}) => {
//   return POST('Tenant/google/connect', {adminEmail, serviceAccount})
// }

const googleConnect = () => {
  return POST('tenant/google/classroom/connect')
}

const groupConnect = () => {
  return GET('tenant/generate-business-delegated-microsoft-url')
}

const generateBusinessMicrosoftUrl = () => {
  return GET('tenant/generate-business-microsoft-url')
}

const generatePersonalMicrosoftUrl = () => {
  return GET('tenant/generate-personal-microsoft-url')
}

const generatePersonalGoogleReauthUrl = () => {
  return GET('tenant/generate-personal-google-reauth-url')
}

const generatePersonalMicrosoftReauthUrl = () => {
  return GET('tenant/generate-personal-microsoft-reauth-url')
}

const generateDropboxUrl = (levelType) => {
  return GET(`tenant/dropbox/connect?levelType=${levelType}`)
}

const generateBoxUrl = (levelType) => {
  return GET(`tenant/box/connect?levelType=${levelType}`)
}

const generateSalesforceUrl = (levelType) => {
  return GET(`tenant/salesforce/connect?levelType=${levelType}`)
}

const generatePersonalBoxReauthUrl = () => {
  return GET('tenant/box/reconnect')
}

const generatePersonalDropboxReauthUrl = () => {
  return GET('tenant/dropbox/reconnect')
}

export {
  register,
  authenticate,
  getSelf,
  googleConnect,
  generateDropboxUrl,
  generateBoxUrl,
  generateSalesforceUrl,
  generateBusinessMicrosoftUrl,
  generatePersonalMicrosoftUrl,
  generatePersonalMicrosoftReauthUrl,
  generatePersonalGoogleReauthUrl,
  generatePersonalBoxReauthUrl,
  generatePersonalDropboxReauthUrl,
  groupConnect,
}
